import { handleActions } from 'redux-actions';
import { defaultChangePasswordWidgetState } from './defaults';
import { ChangePasswordWidgetData } from './types';
import { initSecurityPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveRequestMetaReducer,
} from '../utils';
import {
  setChangePasswordWidgetCurrentPassword,
  setChangePasswordWidgetNewPassword,
  saveChangePassword,
  saveChangePasswordSuccess,
  saveChangePasswordFailure,
  setChangePasswordWidgetNewPasswordRepeat,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergeChangePasswordWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(defaultChangePasswordWidgetState);

export default handleActions<ChangePasswordWidgetData, any>(
  {
    [initSecurityPage.toString()]: (
      state,
      action: ReturnType<typeof initSecurityPage>
    ) => {
      const data: ChangePasswordWidgetData['initialData'] =
        defaultChangePasswordWidgetState.initialData;

      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setChangePasswordWidgetCurrentPassword.toString()]: (
      state,
      action: ReturnType<typeof setChangePasswordWidgetCurrentPassword>
    ) =>
      mergeChangePasswordWidgetDataChange(state, {
        currentPassword: action.payload.currentPassword,
      }),
    [setChangePasswordWidgetNewPassword.toString()]: (
      state,
      action: ReturnType<typeof setChangePasswordWidgetNewPassword>
    ) =>
      mergeChangePasswordWidgetDataChange(state, {
        newPassword: action.payload.newPassword,
      }),
    [setChangePasswordWidgetNewPasswordRepeat.toString()]: (
      state,
      action: ReturnType<typeof setChangePasswordWidgetNewPasswordRepeat>
    ) =>
      mergeChangePasswordWidgetDataChange(state, {
        newPasswordRepeat: action.payload.newPasswordRepeat,
      }),
    ...saveRequestMetaReducer({
      initialAction: saveChangePassword,
      successAction: saveChangePasswordSuccess,
      failureAction: saveChangePasswordFailure,
    }),
  },
  defaultChangePasswordWidgetState
);
